
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116 90"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"115","height":"89","x":".5","y":".5","fill":"#FFF","stroke":"#71798A","rx":"4"}}),_c('path',{attrs:{"stroke":"#C0C8D7","stroke-linecap":"round","stroke-width":"3","d":"M33 65.979c64.364-6.127 81.652-12.616 51.862-19.466-29.79-6.85-26.423-11.362 10.098-13.534"}}),_c('path',{attrs:{"stroke":"#05B5E4","stroke-width":"2","d":"M90 16h12a1 1 0 011 1v10.148a1 1 0 01-.325.737L96 34l-6.675-6.115a1 1 0 01-.325-.737V17a1 1 0 011-1z"}}),_c('path',{attrs:{"stroke":"#003457","stroke-width":"4","d":"M17 17h28a4 4 0 014 4v26.685a2 2 0 01-.608 1.436L31 65.979 13.608 49.12A2 2 0 0113 47.685V21a4 4 0 014-4z"}}),_c('text',{attrs:{"fill":"#003457","font-family":"Gotham-Bold, Gotham","font-size":"28","font-weight":"bold"}},[_c('tspan',{attrs:{"x":"20","y":"45"}},[_v('A')])]),_c('text',{attrs:{"fill":"#05B5E4","font-family":"Gotham-Bold, Gotham","font-size":"12","font-weight":"bold"}},[_c('tspan',{attrs:{"x":"92","y":"27"}},[_v('B')])])])])
          )
        }
      }
    